import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import withStyles from 'material-ui-next/styles/withStyles'
import withTheme from 'material-ui-next/styles/withTheme'
import MediaQuery from 'react-responsive'
import { getTopBarConfig } from '../../selectors'
import breakpoints from '../../styles/breakpoints'
import FiltersMobile from './FiltersMobile'
import FiltersDesktop from './FiltersDesktop'

const styles = theme => ({
  toolbarContent: {
    backgroundColor: theme.swapick.colors.secondaryToolbar,
    boxShadow: '0 2px 5px rgba(0,0,0,.26)',
    [`@media (max-width: ${breakpoints.xs})`]: {
      flex: 1,
      display: 'flex',
    },
  },
  toolbar: {
    opacity: 0,
    pointerEvents: 'none',
    transition: 'height 400ms, opacity 200ms',
    '&.open': {
      pointerEvents: 'auto',
      backgroundColor: theme.swapick.colors.secondarytoolbar,
      border: '1px solid #ccc',
      opacity: 1,
    },
    [`@media (max-width: ${breakpoints.xs})`]: {
      flex: 1,
      display: 'flex',
    },
  },
})

class FiltersToolbar extends PureComponent {
  render() {
    const { classes, openFilters, filtersLines, theme } = this.props

    const filtersDesktopHeight =
      filtersLines * theme.swapick.dimensions.filtersToolbar

    return (
      <div className={classes.toolbarContent}>
        <MediaQuery maxWidth={breakpoints.xs}>
          {onMobile => (
            <div
              style={{
                height: openFilters
                  ? onMobile ? undefined : filtersDesktopHeight
                  : 0,
              }}
              className={classNames(classes.toolbar, { open: openFilters })}>

              {onMobile ? <FiltersMobile /> : <FiltersDesktop />}
            </div>
          )}
        </MediaQuery>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const config = getTopBarConfig(state)

  return {
    openFilters: config.openFilters,
    filtersLines: config.filtersLines,
  }
}

export default withRouter(
  withTheme()(withStyles(styles)(connect(mapStateToProps)(FiltersToolbar)))
)



// WEBPACK FOOTER //
// ./src/common/TopBar/FiltersToolbar.js